import { Component, Input, OnInit } from '@angular/core';
import { ContactDetailsService } from '../contact-details.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NotificationService } from '../../shared/notification.service';
import { HistoryService } from '../contact-history/history.service';
import { ContactsService } from '../../contacts/shared/services/contacts.service';
import { ContactDetails, ContactDetailsRequestData } from '../contacts-details.model';
import { ValidateExternalLink } from './import-details.validators';

@Component({
  selector: 'cc-import-details',
  templateUrl: './import-details.component.html',
  styleUrls: ['./import-details.component.scss']
})
export class ImportDetailsComponent implements OnInit {
  @Input() recordId: number;
  @Input() eventId: number;
  @Input() hyperLink: string;
  public loading = false;

  public contact: ContactDetails;
  public importData: ContactDetailsRequestData;
  public detailsForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    public contactDetailsService: ContactDetailsService,
    public notificationService: NotificationService,
    public historyService: HistoryService,
    public contactsService: ContactsService
  ) {}

  ngOnInit() {
    this.refreshData(this.recordId);
    this.contactsService.setTagEditorPosition({
      top: 0,
      left: 0,
      rowId: this.recordId
    });
    this.initForm(this.contact);
  }

  initForm(data) {
    const externalLink = data && data.externalLink ? data.externalLink : '';

    this.detailsForm = this.fb.group({
      firstName: [data && data.firstName ? data.firstName : ''],
      lastName: [data && data.lastName ? data.lastName : ''],
      company: [data && data.company ? data.company : ''],
      email: [data && data.email ? data.email : ''],
      externalLink: [externalLink, ValidateExternalLink()],
    });
  }

  isExternalLinkValid() {
    return this.detailsForm.get('externalLink').valid;
  }

  refreshData(id: number) {
    this.loading = false;
    this.contactDetailsService.getContactDetails(id).subscribe((data: any) => {
      this.contact = data;
      this.loading = false;
      this.initForm(this.contact);
      this.hyperLink = this.contact.externalLink;
    });
  }

  saveChanges() {
    this.loading = true;
    const formData = {
      firstName: this.detailsForm.get('firstName').value,
      lastName: this.detailsForm.get('lastName').value,
      company: this.detailsForm.get('company').value,
      email: this.detailsForm.get('email').value,
      externalLink: this.detailsForm.get('externalLink').value
    };

    const updatedData = { ...this.importData, ...formData };
    this.contactDetailsService.saveContactDetails(this.recordId, updatedData).subscribe(
      () => {
        this.notificationService.open('EVENT_DETAILS.CHANGED_IMPORTED_DATA');
        this.historyService.refreshHistory(this.recordId);
        this.loading = false;
      },
      error => {
        this.notificationService.open(error);
      }
    );
    this.hyperLink = updatedData.externalLink;
  }
}
